export default __webpack_public_path__ + "static/media/eild_header_logo.8bf73972.png";